
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Stocktaking_$reflection } from "../../Shared/Stocktaking.js";
import { record_type, union_type, class_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { RequestedValue$1_$reflection, AccountSettings_$reflection } from "../../Shared/Shared.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StocktakingsFetched", "AccountSettingsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Stocktaking.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(Stocktaking_$reflection())]], [["Item", AccountSettings_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(Stocktakings, AccountSettings) {
        super();
        this.Stocktakings = Stocktakings;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("Stocktaking.Overview.Types.State", [], State, () => [["Stocktakings", RequestedValue$1_$reflection(list_type(Stocktaking_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

